import React from 'react'

function RoomData(props) {
    return <p>{props.data}</p>;
}

export default RoomData;